var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"knowledge-wrapper"},[(_vm.searchClient)?_c('KnowledgeBaseCategories'):_c('div',{staticClass:"loading-screen"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#1e75e8","size":"70"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }